/*
 * BDC header (sections/bdc-header.liquid): opens/closes the mobile navigation drawer.
 * The drawer is a native <dialog> (focus trap + Esc for free); this adds the burger
 * button wiring, backdrop-click close, page scroll lock and aria-expanded sync.
 * Desktop dropdowns are pure CSS (:hover / :focus-within).
 */
if (!customElements.get('bdc-header')) {
  class BdcHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('#BdcDrawer');
      this.openers = Array.from(this.querySelectorAll('[data-bdc-drawer-open]'));
      if (!this.drawer || typeof this.drawer.showModal !== 'function') return;

      this.openers.forEach((button) => button.addEventListener('click', () => this.open()));
      this.drawer.querySelectorAll('[data-bdc-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => this.drawer.close());
      });
      // A click on the ::backdrop lands on the dialog element itself.
      this.drawer.addEventListener('click', (event) => {
        if (event.target === this.drawer) this.drawer.close();
      });
      this.drawer.addEventListener('close', () => {
        document.documentElement.style.removeProperty('overflow');
        this.openers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      });
    }

    open() {
      this.drawer.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.openers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
    }
  }

  customElements.define('bdc-header', BdcHeader);
}
